import React from 'react'
import { MdSecurity } from 'react-icons/md'
import { FaHandsHelping } from 'react-icons/fa'
import { FaCogs } from 'react-icons/fa'
import { FaRegSmile } from 'react-icons/fa'
import styled from 'styled-components'

const StyledLGYGraphicsListSection = styled.section`
  svg {
    color: #02bfe7
  }
`

const LGYGraphicListSection = () =>
  <StyledLGYGraphicsListSection className='lgy-graphic-list-section usa-section usa-graphic_list'>
    <div className='usa-grid usa-graphic_list-row'>
      <div className='usa-width-one-half usa-media_block'>
        <MdSecurity className='usa-media_block-img' size='124' />
        <div className='usa-media_block-body'>
          <h3>More secure</h3>
          <p>Two factor authentication reduces the risk of account and data theft.</p>
        </div>
      </div>
      <div className='usa-width-one-half usa-media_block'>
        <FaRegSmile className='usa-media_block-img' size='124' />
        <div className='usa-media_block-body'>
          <h3>Easier to use</h3>
          <p>Intuitive and responsive design helps you find and do more, faster.</p>
        </div>
      </div>
    </div>
    <div className='usa-grid usa-graphic_list-row'>
      <div className='usa-width-one-half usa-media_block'>
        <FaHandsHelping className='usa-media_block-img' size='124' />
        <div className='usa-media_block-body'>
          <h3>Get the help you need</h3>
          <p>Easy to read documentation—and a new, streamlined way to contact our help desk with any problems you encounter.</p>
        </div>
      </div>
      <div className='usa-width-one-half usa-media_block'>
        <FaCogs className='usa-media_block-img' size='124' />
        <div className='usa-media_block-body'>
          <h3>Our servers love your servers</h3>
          <p>Our growing REST API allows you to see and make changes automatically.</p>
        </div>
      </div>
    </div>
  </StyledLGYGraphicsListSection>

export default LGYGraphicListSection
